/*
 * Model for campaign
 */

define([
  "backbone",
  "jquery",
  "messaging/messenger",
  "configuration/properties",
  "./campaignLaunch/campaignLaunchModel",
], function (Backbone, $, Messenger, Properties, CampaignLaunchModel) {
  "use strict";

  const CampaignModel = {};

  CampaignModel.JOBRUNR_JOBS_STATUSES = {
    SCHEDULED: "SCHEDULED",
    ENQUEUED: "ENQUEUED",
    PROCESSING: "PROCESSING",
    FAILED: "FAILED",
    SUCCEEDED: "SUCCEEDED",
    DELETED: "DELETED",
  };

  CampaignModel.campaign = Backbone.Model.extend({
    idAttribute: "id",
    defaults: {
      name: "",
      description: "",
      lock: false,
    },
    validateCampaignName: function (name) {
      // Validate that campaign name is unique
      const isDuplicate = this.collection.some(
        (otherCampaign) =>
          this !== otherCampaign && name.toUpperCase() === otherCampaign.get("name").toUpperCase(),
      );

      if (isDuplicate) {
        return $.t("admin.campaigns.duplicateName");
      }
    },
    validateAttribute: function (attributeName, attributeValue) {
      if (attributeName === "name") {
        return (
          this.validateRequiredValue(attributeValue, {
            emptyValueMessage: "admin.campaigns.noName",
            maxLength: 100,
          }) ||
          this.validateSafeCharacters(attributeValue) ||
          this.validateCampaignName(attributeValue)
        );
      }
    },
    isSuccessful: function () {
      return this.get("startTimestamp") && this.get("finishTimestamp");
    },
    getAllCampaignJobs: function (options) {
      const forceFetch = options && options.forceFetch;
      if (!forceFetch && this.campaignScheduleCol) {
        return this.campaignScheduleCol;
      }
      if (forceFetch && this.campaignScheduleCol) {
        this.campaignScheduleCol.fetch();
        return this.campaignScheduleCol;
      }
      const subModelOptions = Object.assign(
        {
          modelClass: CampaignLaunchModel.campaignScheduleList,
          urlExtension: "/schedule",
        },
        options,
      );
      this.campaignScheduleCol = this.getSubModel2(this.campaignScheduleCol, subModelOptions);
      return this.campaignScheduleCol;
    },
    clearAllSchedule: function (options) {
      let campaignModel = this;
      return new Promise((resolve, reject) => {
        const kbId = Messenger.reqres.request("active:kb");
        const modelOptions = {
          url: `${Properties.adminRootURL}/kbs/${kbId}/campaigns/${campaignModel.get(
            "id",
          )}/schedule`,
          success: (model) => {
            resolve(model);
          },
          error: (_model, response) => {
            reject(Messenger.getErrorFromResponse(response));
          },
        };
        campaignModel.sync("delete", campaignModel, modelOptions);
      });
    },
  });

  CampaignModel.campaigns = Backbone.Collection.extend({
    model: CampaignModel.campaign,
    addCampaign: function (attributes) {
      const campaign = new CampaignModel.campaign(attributes);
      this.add(campaign);
      return campaign;
    },
    comparator: function (a, b) {
      return Backbone.textComparator(a, b, "name");
    },
    initializeCustom: function (options) {
      this.kbId = options.kbId;
      this.on("sync", function () {
        this.sort();
      });
      if (this.kbId) {
        this.fetch();
      }
    },
    url: function () {
      return `${Properties.rootURL}/${this.kbId}/campaigns`;
    },
  });

  CampaignModel.campaignsWithDefault = CampaignModel.campaigns.extend(
    {
      url: function () {
        return `${Properties.rootURL}/${this.kbId}/campaignsWithDefault`;
      },
    },
    {
      DEFAULT_CAMPAIGN_ID: -1,
    },
  );

  return CampaignModel;
});
